// extracted by mini-css-extract-plugin
module.exports = {"img-text-card-box":"eF","imgTextCardBox":"eF","text-box":"eG","textBox":"eG","remark-val":"eH","remarkVal":"eH"};